<template>
  <div>
    <audio
      controls="controls"
      hidden
      src="../../../assets/err.mp3"
      ref="erraudio"
    ></audio>
    <audio
      controls="controls"
      hidden
      src="../../../assets/success.wav"
      ref="successaudio"
    ></audio>

    <div class="item-info">
      <ul class="item-ul" v-for="(item, index) in list.taskDetail" :key="index">
        <li class="item-li">
          <div class="item-left">
            <span>发货编码</span><span>{{ item.sourceNo }}</span>
          </div>
          <div class="item-right">
            <span>货柜号</span
            ><span>{{ item.containerNo }}({{ item.jpContainerNo }})</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>是否带电</span><span>{{ item.isElectricityText }}</span>
          </div>
          <div class="item-right">
            <span>供应商</span><span>{{ item.supplierCode }}</span>
          </div>
        </li>

        <li class="item-li">
          <div class="item-left">
            <span>SKU名称</span>
            <span class="hiddenText">{{ item.productNameCN }}</span>
          </div>
          <div class="item-right">
            <!-- <span>调入仓</span><span>{{ item.warehouseName }}</span> -->
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>调入仓</span><span>{{ item.warehouseName }}</span>
          </div>
          <div class="item-left">
            <!-- <span>SKU名称</span>
            <span class="hiddenText">{{ item.productNameCN }}</span> -->
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>是否退税</span><span>{{ item.isReturnTaxText }}</span>
          </div>
          <div class="item-right">
            <span>品牌</span><span>{{ item.brand }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>FNSKU</span><span>{{ item.fnsku }}</span>
          </div>
          <div class="item-right">
            <span>型号</span><span>{{ item.model }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>shipmentid</span><span>{{ item.shipmentID }}</span>
          </div>
          <div class="item-right">
            <span>SKU</span><span>{{ item.skuCode }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>原SKU</span><span>{{ item.originalSKU }}</span>
          </div>
          <div class="item-right" style="white-space: nowrap">
            <span>{{ item.actualQty }}/{{ item.quantity }}</span
            ><span>(打包数/调拨数)</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>{{ item.barMarkDoHandle }}</span>
          </div>
          <div class="item-right" style="white-space: nowrap">
            <span>柜子最大箱号 {{ list.maxBoxNo }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="conventionalBox-info">
      <p class="p-title"><span style="color: red">*</span>常规箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info1"
        :key="index"
      >
        <ul>
          <li class="singleBoxLi">
            <div>
              <span>单箱数量</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.singleBoxQty"
                @change="inputStockSKUCodeChange(index)"
                @input="inputParseIntNumChange('info1', index, 'singleBoxQty')"
              />
            </div>
            <div>
              <span>X <span style="color: #a5081a">箱数</span></span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxCount"
                @change="inputBoxCodeChange(index)"
                @input="inputParseIntNumChange('info1', index, 'boxCount')"
              />
            </div>
            <div>
              <span>总数：</span>
              <span>{{
                Number(item.singleBoxQty) * Number(item.boxCount) || 0
              }}</span>
              <span class="red tips" style="left: -22px" v-if="item.quantityOut"
                >装箱数已超调拨数</span
              >
              <span
                class="red tips"
                style="left: -120px"
                v-if="item.BoxNoOrBoxCount"
                >箱号与箱数不符</span
              >
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>箱号起：</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.startBoxNo"
                @input="inputLenChange('info1', index, 'startBoxNo', 0)"
                @change="inputNumChange('info1', index, 'startBoxNo', 0)"
                placeholder="起始箱号"
              />
            </div>
            <div>
              <span>箱号止：</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.endBoxNo"
                @input="inputLenChange('info1', index, 'endBoxNo', 0)"
                @change="inputNumChange('info1', index, 'endBoxNo', 0)"
                placeholder="截止箱号"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info1', index, 'boxLength', 2)"
                @change="inputNumChange('info1', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info1', index, 'boxWidth', 2)"
                @change="inputNumChange('info1', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info1', index, 'boxHeight', 2)"
                @change="inputNumChange('info1', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                style="max-width: 40%"
                v-model="item.boxWeight"
                @input="inputLenChange('info1', index, 'boxWeight', 2)"
                @change="inputNumChange('info1', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div class="btnCls">
              <span class="btn" @click="readDevice(item)">读取设备</span>
              <span class="delInfo" @click="del(1, index)">{{
                info1.length === 1 ? "清空" : "删除"
              }}</span>
              <span class="addInfo" @click="add(1)">添加</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="conventionalBox-info">
      <p class="p-title">尾箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info2"
        :key="index"
      >
        <ul>
          <li class="singleBoxLi">
            <div>
              <span>单箱数量</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.singleBoxQty"
                @change="inputParseIntNumChange('info2', index, 'singleBoxQty')"
              />
              <span class="red tips" style="left: 22px" v-if="item.quantityOut"
                >装箱数已超调拨数</span
              >
            </div>
            <div>
              <span>箱号</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxNumber"
                @input="inputLenChange('info2', index, 'boxNumber', 0)"
                @change="inputNumChange('info2', index, 'boxNumber', 0)"
                placeholder="输入箱号"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info2', index, 'boxLength', 2)"
                @change="inputNumChange('info2', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info2', index, 'boxWidth', 2)"
                @change="inputNumChange('info2', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info2', index, 'boxHeight', 2)"
                @change="inputNumChange('info2', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                style="max-width: 40%"
                v-model="item.boxWeight"
                @input="inputLenChange('info2', index, 'boxWeight', 2)"
                @change="inputNumChange('info2', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div class="btnCls">
              <span class="btn" @click="readDevice(item)">读取设备</span>
              <span class="delInfo" @click="del(2, index)">{{
                info2.length === 1 ? "清空" : "删除"
              }}</span>
              <span class="addInfo" @click="add(2)">添加</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="photo" style="width: 100%; margin-top: 10px">
      <div
        class="p-title"
        style="float: left; line-height: 35px; margin-right: 8px"
      >
        <span style="color: red">*</span>打包方式
      </div>
      <van-field
        v-model="list.packagingTypeName"
        placeholder="请选择打包方式"
        @focus="locationFocus"
        style="width: 200px"
        readonly="readonly"
      />
      <input type="hidden" v-model="list.packagingTypeId" />
    </div>
    <div class="barcodeMethodClass">
      <div class="p-title"><span style="color: red">*</span>条码方式</div>
      <div>
        <van-radio-group v-model="WarehouseLable" direction="horizontal">
          <van-radio name="1" shape="square" icon-size="14px">货主贴</van-radio>
          <van-radio name="2" shape="square" icon-size="14px">仓库贴</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="photo">
      <p class="p-title" style="margin-top: 10px">
        <span style="color: red">*</span>打包照片<span style="font-weight: 400"
          >（最少1张）</span
        >
        <span style="margin-left: 10px; margin-right: 4px"> 打印数量</span>
        <span
          ><el-input-number
            v-model="printnum"
            :min="1"
            style="width: 120px"
          ></el-input-number
        ></span>

        <el-button
          type="primary"
          @click="printProductInfo"
          style="
            margin-left: 6px;
            background-color: #169bd5;
            border-radius: 5px;
          "
          >打印产品信息</el-button
        >
      </p>

      <div class="sign-photo-cpntent">
        <div class="sign-photo-box">
          <ul>
            <li
              class="sign-photo-item"
              v-for="(item, index) in skuImg"
              :key="index"
            >
              <span class="delete-icon" @click="deleteImg(index)">x</span>
              <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
              <img
                :src="item"
                class="sign-photo-item-img"
                alt=""
                @click="previewImage(item)"
              />
            </li>

            <li class="sign-photo-btn">
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg()"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                  multiple
                />
                <p @click="chooseImage">
                  <i class="el-icon-camera"></i>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div class="sign-photo-save">
          <button class="submit-btn" @click="submit">保存</button>
        </div>
      </div>
    </div>

    <van-action-sheet
      v-model="showActionSheetForPrint"
      :actions="actionsForPrint"
      closeable
      :lazy-render="false"
      cancel-text="取消"
      description="请先选择打印机"
      @select="actionSheetSelectForPrint"
    />

    <!-- 打包方式下拉 -->
    <van-popup
      v-model="typeShowPicker"
      round
      position="bottom"
      get-container="#app"
    >
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="packagingTypeList"
        @cancel="typeShowPicker = false"
        @confirm="onConfirmType"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
  ImagePreview,
  ActionSheet,
  Radio,
  RadioGroup,
} from "vant";
import { mixins } from "../mobileMixins";
import {
  getBaleSkuDetail,
  getBaleHasBoxNum,
  AddReadyTaskPackaging,
  CheckAddReadyTaskPackaging,
  TaskPackagingPrintSku,
} from "@/api/mobile/bale_api.js";
import { getScanData } from "@/api/mobile/signIn_api";
import { mapMutations } from "vuex";
import { BaseApiUrl } from "@/api/axios_config";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
import axios from "axios";
export default {
  data() {
    return {
      list: {},
      printnum: 0,
      boxMaxNo: 0,
      WarehouseLable: undefined,
      info1: [
        // 常规
        {
          singleBoxQty: "",
          boxCount: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          startBoxNo: "",
          endBoxNo: "",
        },
      ],
      info2: [
        // 尾箱
        {
          singleBoxQty: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          boxNumber: "",
        },
      ],
      skuImg: [],
      imgFiles: [],
      skuCode: "",
      itemName: {
        singleBoxQty: "单箱数量",
        boxCount: "箱数",
        boxLength: "长",
        boxWidth: "宽",
        boxHeight: "高",
        boxWeight: "毛重",
        startBoxNo: "箱号起",
        endBoxNo: "箱号止",
        boxNumber: "箱号",
      },
      saveImgUrlArr: [],
      shippingPlanDetailIDs: [],
      isSetPrinter: false,
      showActionSheetForPrint: false,
      actionsForPrint: [],
      packagingTypeList: [], //打包方式
      typeShowPicker: false,
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getDetail();
    },

    add(type) {
      this[`info${type}`].push(
        type === 1
          ? {
              singleBoxQty: "",
              boxCount: "",
              boxLength: "",
              boxWidth: "",
              boxHeight: "",
              boxWeight: "",
            }
          : {
              singleBoxQty: "",
              boxLength: "",
              boxWidth: "",
              boxHeight: "",
              boxWeight: "",
            }
      );
    },
    printProductInfo() {
      if (this.printnum < 1) {
        Toast("请输入打印数量");
        return;
      }
      let regcarNumber = /^[0-9]*$/;
      if (!regcarNumber.test(this.printnum)) {
        this.$message({
          message: "请输入正整数",
          type: "error",
        });
        return false;
      }

      if (!this.checkAllInfo()) return;

      this.toGetPrinterByUser(this.list.taskDetail[0].warehouseID);
    },
    onConfirmType(val) {
      this.$set(this.list, "packagingTypeId", val.packagingTypeId);
      this.$set(this.list, "packagingTypeName", val.text);
      this.typeShowPicker = false;
    },
    locationFocus() {
      this.typeShowPicker = true;
    },
    printskuinfo() {
      const boxlist = [];
      this.info1.forEach((item, i) => {
        if (item.boxCount) {
          item.boxType = 1;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          boxlist.push(item);
        }
      });

      this.info2.forEach((item, i) => {
        if (item.singleBoxQty) {
          item.startBoxNo = item.boxNumber;
          item.endBoxNo = item.boxNumber;
          item.boxType = 3;
          item.boxCount = 1;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          boxlist.push(item);
        }
      });

      if (boxlist.length) {
        if (this.checkActualQty() == 1) {
          return Toast("装箱数已超调拨数");
        }
      }
      var changguiBox = boxlist.find((x) => x.boxType == 1);

      if (changguiBox == null || changguiBox.length <= 0) {
        return Toast("常规箱子信息不能为空");
      }

      console.log(changguiBox.boxWidth);
      console.log(changguiBox.boxHeight);
      console.log(changguiBox.boxWeight);
      console.log(changguiBox.singleBoxQty);

      var arr2 = [];
      var arr3 = [];
      boxlist.forEach((item, index) => {
        if (item.boxType == 1) {
          arr2.push(item.boxCount);
        }
      });

      boxlist.forEach((item, index) => {
        if (item.boxType == 3) {
          arr3.push(item.boxCount);
        }
      });

      var changguiBoxNum = arr2.reduce(
        (prev, cur) => Number(prev) + Number(cur)
      );
      var weixiangBoxNum = 0;
      console.log("arr3.length" + arr3.length);
      if (arr3.length > 0) {
        weixiangBoxNum = arr3.reduce((prev, cur) => Number(prev) + Number(cur));
      }
      var BoxNum = "";
      if (weixiangBoxNum > 0) {
        BoxNum = changguiBoxNum + "+" + weixiangBoxNum;
      } else {
        BoxNum = changguiBoxNum;
      }

      this.printSuccess = false;
      var data = [];
      data.push({
        sku: this.list.taskDetail[0].skuCode,
        boxCount: Number(this.printnum),
        productNameCN: this.list.taskDetail[0].productNameCN,
        warehouseId: this.list.taskDetail[0].warehouseID,
        BoxLenght: changguiBox.boxLength,
        BoxWidth: changguiBox.boxWidth,
        BoxHeight: changguiBox.boxHeight,
        BoxWeight: changguiBox.boxWeight,
        BoxNum: BoxNum,
        OneBoxNum: changguiBox.singleBoxQty,
        FNSKU: this.list.taskDetail[0].fnsku,
      });
      TaskPackagingPrintSku(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.jsonpPrint(res.response);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      //  console.log('打印机地址是:'+url);

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();
          Toast.success("打印成功");
          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          Toast.fail("打印失败");
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
            Toast.success("打印成功");
          } else {
            Toast.fail("打印失败");
          }
        });
    },

    // 查询用户是否设置打印机
    toGetPrinterByUser(warehouseID) {
      const data = {
        moduleType: 4, // 打包箱子条码
        wareId: warehouseID,
      };
      this.isSetPrinter = false;
      this.actionsForPrint = [];

      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          Toast("请选择打印机");
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
            console.log(this.actionsForPrint);
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
          this.printskuinfo();
        }
      });
      console.log("显示打印机" + this.isSetPrinter);
    },

    actionSheetSelectForPrint(act, i) {
      this.toAddUserPrinter(act.id);
      this.showActionSheetForPrint = false;
    },
    // 新增打印机
    toAddUserPrinter(id) {
      const data = {
        moduleType: 4, // 打包箱号条码
        printerInfoID: id,
      };
      AddUserPrinter(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200) {
          this.isSetPrinter = true;
          Toast.success(msg || "添加打印机成功");
        } else {
          Toast(msg);
        }
      });
    },

    del(type, i) {
      const that = this;
      const len = that[`info${type}`].length;
      const msg = len === 1 ? "清空" : "删除";
      Dialog.confirm({
        title: msg,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: `确认进行${msg}操作吗？`,
      })
        .then(() => {
          if (len === 1) {
            that[`info${type}`].splice(i, 1);
            that.add(type);
            return;
          }

          that[`info${type}`].splice(i, 1);
        })
        .catch(() => {});
    },

    getDetail() {
      const { shippingPlanDetailID, stockingTaskID } = this.$route.query;
      const data = {
        shippingPlanDetailIDS: shippingPlanDetailID,
        stockingTaskID: stockingTaskID,
      };
      getBaleSkuDetail(data).then((res) => {
        if (res.status === 200 && res.success) {
          const { response } = res;
          let flag = false;
          this.WarehouseLable = response.warehouseLable + "";
          if (response.wholeCase.length) {
            this.info1 = response.wholeCase;
            response.wholeCase.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
          }

          if (response.theTrunk.length) {
            response.theTrunk.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
            this.info2 = response.theTrunk;
          }

          if (response.urlPath && response.urlPath.length) {
            response.urlPath.forEach((item, i) => {
              response.urlPath[
                i
              ] = `data:image/jpg;base64,${response.urlPath[i]}`;
            });

            this.skuImg = response.urlPath;
          }

          this.saveImgUrlArr = response.imgUrlList || [];

          this.list = response;
          this.boxMaxNo = response.maxBoxNo;
          let typeArr = [];
          response.packagingTypeList.forEach((item) => {
            typeArr.push({
              text: `${item.packagingTypeName}`,
              packagingTypeId: item.packagingTypeId,
            });
          });

          this.packagingTypeList = typeArr;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 处理整箱的单箱数量
    inputStockSKUCodeChange(i) {
      if (this.info1[i].singleBoxQty.length > 10) {
        this.$set(
          this.info1[i],
          "singleBoxQty",
          this.info1[i].singleBoxQty.slice(0, 10)
        );
      }
    },

    // 处理整箱的箱数
    inputBoxCodeChange(i) {
      if (String(this.info1[i].boxCount).length > 10) {
        this.$set(
          this.info1[i],
          "boxCount",
          Number(String(this.info1[i].boxCount).slice(0, 10))
        );
      }
    },
    createBoxNo() {
      this.boxMaxNo = this.list.maxBoxNo;
      this.info1.forEach((item, i) => {
        if (item.singleBoxQty > 0 && item.boxCount > 0) {
          item.startBoxNo = this.boxMaxNo + 1;
          item.endBoxNo = this.boxMaxNo + item.boxCount;
          this.boxMaxNo = this.boxMaxNo + item.boxCount;
        }
      });

      this.info2.forEach((item, i) => {
        if (item.singleBoxQty > 0) {
          item.boxNumber = this.boxMaxNo + 1;
          this.boxMaxNo = this.boxMaxNo + 1;
        }
      });
    },
    // 前端验证打包数是否大于调拨数
    checkActualQty() {
      let arr = [],
        that = this;
      for (let i = 0; i < this.info1.length; i++) {
        arr.push(
          Number(this.info1[i].singleBoxQty) * Number(this.info1[i].boxCount) ||
            0
        );
      }

      for (let j = 0; j < this.info2.length; j++) {
        arr.push(Number(this.info2[j].singleBoxQty) || 0);
      }

      var sum = arr.reduce(function (prev, cur) {
        return prev + cur;
      });

      function reset(bool) {
        that.info1.forEach((item, i) => {
          that.$set(that.info1[i], "quantityOut", bool);
        });
        that.info2.forEach((item, i) => {
          that.$set(that.info2[i], "quantityOut", bool);
        });
      }

      reset(false);

      if (sum > this.list.taskDetail[0].quantity) {
        reset(true);
        return 1;
      } else if (sum < this.list.taskDetail[0].quantity) {
        return 2;
      }
      return 3;
    },

    // 检测是否写完全部信息
    checkAllInfo() {
      const arr1 = [
        "singleBoxQty",
        "boxCount",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "startBoxNo",
        "endBoxNo",
      ];
      const arr2 = [
        "singleBoxQty",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "boxNumber",
      ];
      console.info(this.info1);
      for (let i = 0; i < this.info1.length; i++) {
        const {
          singleBoxQty,
          boxCount,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
          startBoxNo,
          endBoxNo,
        } = this.info1[i];
        if (
          singleBoxQty ||
          boxCount ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight ||
          startBoxNo ||
          endBoxNo
        ) {
          for (const key in this.info1[i]) {
            if (arr1.includes(key)) {
              console.info(key + ":" + this.info1[i][key]);
              if (!this.info1[i][key] || this.info1[i][key] === "0.00") {
                Toast(`请输入整箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }

      // 尾箱一个输入框有值，其它的都必填
      for (let i = 0; i < this.info2.length; i++) {
        const {
          singleBoxQty,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
          boxNumber,
        } = this.info2[i];
        if (
          singleBoxQty ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight ||
          boxNumber
        ) {
          for (const key in this.info2[i]) {
            if (arr2.includes(key)) {
              if (!this.info2[i][key] || this.info2[i][key] === "0.00") {
                Toast(`请输入尾箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    // 判断两个区间是否相交
    isIntersect(arr1, arr2) {
      let start = [Math.min(...arr1), Math.min(...arr2)]; //区间的两个最小值
      let end = [Math.max(...arr1), Math.max(...arr2)]; //区间的两个最大值
      return Math.max(...start) <= Math.min(...end); //最大值里的最小值 是否 小于等于 最大值的最小值
    },

    validateBoxNo() {
      let flag = false;
      for (let i = 0; i < this.info1.length; i++) {
        const { startBoxNo, endBoxNo } = this.info1[i];
        if (!(i === this.info1.length - 1)) {
          let va = this.isIntersect(
            [startBoxNo, endBoxNo],
            [this.info1[i + 1].startBoxNo, this.info1[i + 1].endBoxNo]
          );
          if (va) {
            flag = true;
          }
        }
      }
      return flag;
    },
    showsound(isSuccess) {
      if (isSuccess) {
        this.$refs.successaudio.currentTime = 0;
        this.$refs.successaudio.play();
      } else {
        this.$refs.erraudio.currentTime = 0;
        this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;

      if (!this.checkAllInfo()) return;

      if (this.list.packagingTypeId === 0 || this.list.packagingTypeId === "") {
        this.showsound(false);
        return Toast("请选择打包方式");
      }
      if (!this.WarehouseLable) {
        this.showsound(false);
        return Toast("请选择条码方式");
      }
      // 判断startBoxNo和endBoxNo是否有交集
      if (this.validateBoxNo()){
        this.showsound(false);
        return Toast("尾箱号范围有交集");
      } 
      if (this.saveImgUrlArr.length < 1) 
      {
        this.showsound(false);
        return Toast("最少1张照片");
      }

      const data = [];
      this.info1.forEach((item, i) => {
        if (item.boxCount) {
          item.boxType = 1;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          data.push(item);
        }
      });

      this.info2.forEach((item, i) => {
        if (item.singleBoxQty) {
          item.startBoxNo = item.boxNumber;
          item.endBoxNo = item.boxNumber;
          item.boxType = 3;
          item.boxCount = 1;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          item.startBoxNo = item.startBoxNo;
          item.endBoxNo = item.endBoxNo;
          data.push(item);
        }
      });

      if (data.length) {
        if (this.checkActualQty() == 1) {
          this.showsound(false);
          return Toast("装箱数已超调拨数");
        } else if (this.checkActualQty() == 2) {
          const { sourceNo, skuCode } = this.list.taskDetail[0];
          Dialog.confirm({
            title: "确认",
            confirmButtonText: "确认无误",
            cancelButtonText: "取消",
            message: `发货计划：${sourceNo}，sku：${skuCode}，实际打包数量小于调拨数量，请确认是否无误？`,
          })
            .then(() => {
              data.forEach((item, i) => {
                delete data[i].quantityOut;
                delete data[i].BoxNoOrBoxCount;
                delete data[i].boxNoRepet;
                delete data[i].triggerCount;
              });

              let ids = [this.list.taskDetail[0].shippingPlanDetailID];
              const obj = {
                boxList: data,
                file: this.saveImgUrlArr,
                WarehouseLable: this.WarehouseLable,
                shippingPlanDetailIDs: ids.toString() || "",
                packagingTypeId: this.list.packagingTypeId,
              };

              CheckAddReadyTaskPackaging(obj).then((checkres) => {
                Toast.clear();
                if (checkres.status === 200 && checkres.success) {
                  Toast.loading({
                    message: "打包中...",
                    forbidClick: true,
                    overlay: true,
                    duration: 0,
                  });

                  AddReadyTaskPackaging(obj).then((res) => {
                    Toast.clear();
                    if (res.status === 200 && res.success) {
                      this.showsound(true);
                      Toast.success(res.msg || "打包成功");

                      setTimeout(function () {
                        that.$router.go(-1);
                      }, 1500);
                    } else {
                      this.showsound(false);
                      Toast.fail(res.msg);
                    }
                  });
                } else {
                  Dialog.confirm({
                    title: "箱规有变动",
                    message: checkres.msg,
                    confirmButtonText: "确认打包",
                    cancelButtonText: "取消",
                  })
                    .then(() => {
                      Toast.loading({
                        message: "打包中...",
                        forbidClick: true,
                        overlay: true,
                        duration: 0,
                      });

                      AddReadyTaskPackaging(obj).then((res) => {
                        Toast.clear();
                        if (res.status === 200 && res.success) {
                          this.showsound(true);
                          Toast.success(res.msg || "打包成功");

                          setTimeout(function () {
                            that.$router.go(-1);
                          }, 1500);
                        } else {
                          this.showsound(false);
                          Toast.fail(res.msg);
                        }
                      });
                    })
                    .catch(() => {
                      // on cancel
                    });
                }
              });
            })
            .catch(() => {
              return;
            });
        } else {
          data.forEach((item, i) => {
            delete data[i].quantityOut;
            delete data[i].BoxNoOrBoxCount;
            delete data[i].boxNoRepet;
            delete data[i].triggerCount;
          });

          let ids = [this.list.taskDetail[0].shippingPlanDetailID];
          const obj = {
            boxList: data,
            file: this.saveImgUrlArr,
            WarehouseLable: this.WarehouseLable,
            shippingPlanDetailIDs: ids.toString() || "",
            packagingTypeId: this.list.packagingTypeId,
          };

          CheckAddReadyTaskPackaging(obj).then((checkres) => {
            Toast.clear();
            if (checkres.status === 200 && checkres.success) {
              Toast.loading({
                message: "打包中...",
                forbidClick: true,
                overlay: true,
                duration: 0,
              });

              AddReadyTaskPackaging(obj).then((res) => {
                Toast.clear();
                if (res.status === 200 && res.success) {
                  this.showsound(true);
                  Toast.success(res.msg || "打包成功");

                  setTimeout(function () {
                    that.$router.go(-1);
                  }, 1500);
                } else {
                  this.showsound(false);
                  Toast.fail(res.msg);
                }
              });
            } else {
              Dialog.confirm({
                width: 400,
                title: "箱规异常请确认",
                message: checkres.msg,
                confirmButtonText: "确认打包",
                cancelButtonText: "取消",
              })
                .then(() => {
                  Toast.loading({
                    message: "打包中...",
                    forbidClick: true,
                    overlay: true,
                    duration: 0,
                  });

                  AddReadyTaskPackaging(obj).then((res) => {
                    Toast.clear();
                    if (res.status === 200 && res.success) {
                      this.showsound(true);
                      Toast.success(res.msg || "打包成功");

                      setTimeout(function () {
                        that.$router.go(-1);
                      }, 1500);
                    } else {
                      this.showsound(false);
                      Toast.fail(res.msg);
                    }
                  });
                })
                .catch(() => {
                  // on cancel
                });
            }
          });
        }
      } else {
        this.showsound(false);
        return Toast("请至少输入一种类型");
      }
    },

    deleteImg(i) {
      this.skuImg.splice(i, 1);
      // this.imgFiles.splice(i,1)
      this.saveImgUrlArr.splice(i, 1);
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    chooseImage() {
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    inputLenChange(name, i, field, fix = 1) {
      let s = this[name][i][field];
      if (s.includes(".")) {
        const m = s.split(".")[0];
        if (m.length > 3) {
          this.$set(this[name][i], field, Number(`${m.slice(0, 3)}.${m[1]}`));
        }
      } else {
        if (s.length > 4) {
          this.$set(this[name][i], field, this[name][i][field].slice(0, 4));
        }
      }
    },

    inputNumChange(name, i, field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let s = this[name][i][field];

      let num = toF(s, fix);
      if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }

      this.$set(this[name][i], field, num);
    },

    inputParseIntNumChange(name, i, field) {
      let num = Number(this[name][i][field]);
      if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      this.$set(this[name][i], field, parseInt(num));

      if (name === "info1" && field === "boxCount") {
        if (String(this.info1[i].boxCount).length > 10)
          this.$set(
            this.info1[i],
            "boxCount",
            Number(String(this.info1[i].boxCount).slice(0, 10))
          );
      }
      this.createBoxNo();
    },

    readDevice(item) {
      const data = {
        skuCode: this.list.taskDetail[0].skuCode,
        areaCode: "",
      };

      Toast.loading({
        message: "读取中...",
        forbidClick: true,
      });
      getScanData(data).then((res) => {
        Toast.clear();

        if (res.status === 200 && res.success) {
          //this.isReadDevice = true
          const { goodLength, goodHeight, goodWeight, goodWidth } =
            res.response;
          this.$set(item, "boxLength", goodLength);
          this.$set(item, "boxWidth", goodWidth);
          this.$set(item, "boxHeight", goodHeight);
          this.$set(item, "boxWeight", goodWeight);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
  },

  watch: {
    // 'info2': {
    // 	handler(n, o) {
    // 	},
    // 	deep: true
    // }
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

.btn {
  //   position: absolute;
  right: 25%;
  background-color: #169bd5;
  color: #fff;
  border-radius: 5px;
  width: 100px;
  text-align: center;
  line-height: 30px;
}

.print {
  background-color: #169bd5;
  color: #fff;
  width: 180px;
}

.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;

  .item-ul {
    padding-left: 18.5%;

    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;

      & > div {
        flex: 1;
        line-height: 25px;
        display: flex;
        max-width: 100%;

        & > span {
          vertical-align: text-top;

          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }

          &:last-child {
            color: #3d5064;
          }
        }

        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .item-info {
    font-size: 12px;

    .item-ul {
      padding: 0 2%;

      .item-li {
        .item-right {
          margin-left: 3%;
        }

        & > div {
          line-height: 22px;

          & > span {
            &:first-child {
              padding-right: 6px;
            }

            &:last-child {
              flex: 1;
            }
          }
        }
      }
    }
  }
}

.conventionalBox-info {
  font-size: 14px;

  .signInDetail-btnBox {
    background-color: #fbf9fe;
    padding: 10px;
    border-bottom: 1px solid #cccccc;

    li {
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }

    .volume {
      min-width: 10%;
      max-width: 27%;
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      border: 0;
      background-color: #fbf9fe;
      border-bottom: 1px solid #757474;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    &:last-child {
      border-bottom: 0;
    }
  }
}

.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

.photo {
  font-size: 14px;
}

.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}

.hidden {
  display: none;
}

.addInfo,
.delInfo {
  right: 1%;
  color: #027db4;
}

.delInfo {
  right: 13%;
  color: #da2727;
}

.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}

::v-deep .van-cell {
  line-height: 20px;
}

.tips {
  position: absolute;
  left: -50px;
  top: 33px;
  font-size: 12px;
  line-height: 20px;
}

.vm {
  vertical-align: middle;
}

.barcodeMethodClass {
  font-size: 14px;
  display: flex;
  margin: 10px 0 0px 0;
  align-items: center;

  .p-title {
    margin-right: 8px;
  }
}

.singleBoxLi {
  padding: 10px 0;

  > div:nth-child(2) {
    margin-left: 4px;
    margin-right: 4px;
  }

  > div {
    width: 33.333%;
    display: flex;

    > :last-child {
      flex: 1;
    }

    > span:first-child {
    }

    .volume {
      max-width: initial !important;
      flex: 1;
    }
  }
}

.btnCls {
  display: flex;
  align-items: flex-end;

  > span {
    margin-right: 4px;
    flex: initial !important;
  }

  .btn {
    padding: 0 10px;
  }
}

.hiddenText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>